import { AppDtoAgentEnum } from '@coretava/api/core-service';
import { VtexCart } from './vtex';
import { CartSdkConfig } from '../types';
import { ShopifyCart } from './shopify';
import { NotImplementedCart } from './notImplemented';

/**
 * @deprecated
 */
export class EcommerceCartFactory {
  /**
   * @deprecated
   * @param agent
   */
  public static getInstance(agent: AppDtoAgentEnum): CartSdkConfig {
    switch (agent) {
      case 'vtex':
        return new VtexCart();
      case 'shopify':
        return new ShopifyCart();
      default:
        return new NotImplementedCart();
    }
  }
}
